import { Component, OnInit, ElementRef, ViewChild, EventEmitter, Output, Input, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { RouterQuery } from '@datorama/akita-ng-router-store';
import { Auth } from 'aws-amplify';
import { switchMap ,map} from 'rxjs/operators';
import { Observable, interval, Subscription } from 'rxjs';
import { requestsService } from '../services/requests/requests.service';
import { UserQuery } from '../services/user/user.query';
import { DomSanitizer } from '@angular/platform-browser';
import {CookieService} from 'ngx-cookie'
import { ToastrService } from 'ngx-toastr';
import {GenesystokenService} from '../services/genesystoken.service';
import { Config } from '../config';
import { AuthService } from '../services/auth.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild('viewDOM') viewDOM: ElementRef;
  @ViewChild('redirectLink') redirectLink!: ElementRef<HTMLAnchorElement>;
  //readmore variable, its true than read more string will print
  ReadMore:boolean = true
  //hiding info box
  visible:boolean = false
  OneDesignVisible:boolean=false
  oneBusinessVisible:boolean=false
  settingWidth:boolean=false
  reportvisible:boolean=false
  contractSidebar: boolean;
  user: any;
  uservalue:any
  thumbnail:any;
  modules:any=null;
  integrationsApi:any=null;
  Membershipres:any=[]
  onechangeSubitem:boolean=false
  roleList:any=[]
  showManagement:boolean=false
  isPlatformAdmin:boolean=false
  @Input() genesysUserexists:any;
  navList:any=[]
  availableFeatures = {
    OneTrack: false,
    oneChange: false,
    oneTrackAdvanced: false,
    oneDesignOneClone: false,
    oneDesignOneSync: false
  }
  disableUser: boolean = false;
buildNavList() {
  const oneDesignChildren = [];
  const reportChildren = [
    {
      name: 'Package Report',
      icon: 'dashboard.svg',
      iconSelected: 'dashboard-light.svg',
      route: 'packagereport'
    },
    {
      name: 'Flow Promote Report',
      icon: 'dashboard.svg',
      iconSelected: 'dashboard-light.svg',
      route: 'flowPromoteReport'
    }
  ];

  // Conditionally add OneClone and OneClone Report
  if (this.availableFeatures.oneDesignOneClone) {
    oneDesignChildren.push({
      name: 'OneClone',
      route: 'copy-env',
    });

    reportChildren.push({
      name: 'OneClone Report',
      icon: 'dashboard.svg',
      iconSelected: 'dashboard-light.svg',
      route: 'copy-report'
    });
  }

  reportChildren.push({
    name: 'Provisioning History',
    icon: 'dashboard.svg',
    iconSelected: 'dashboard-light.svg',
    route: 'provisioning-history'
  });

  if (this.availableFeatures.oneDesignOneSync) {
    const oneSyncEntry: any = {
      name: 'OneSync',
      route: 'disaster-recovery'
    };
    if (this.showDrOrgSync) {
      oneSyncEntry.children = [{ name: 'DR Org Sync', route: 'dr-org-sync' }];
    }
    oneDesignChildren.push(oneSyncEntry);
  }

  this.navList = [
    {
      name: 'Dashboard',
      route: 'dashboard'
    },
    {
      name: 'OneTrack Lite',
      route: 'OneTrack-Lite'
    },
    {
      name: 'OneTrack Advanced',
      route: 'one-change-advance'
    },
    {
      name: 'OneChange',
      route: 'one-change',
      children: [
        {
          name: 'Package Group',
          icon: 'dashboard.svg',
          iconSelected: 'dashboard-light.svg',
          route: 'package-groupe'
        },
        {
          name: 'Flow Promote',
          icon: 'dashboard.svg',
          iconSelected: 'dashboard-light.svg',
          route: 'flowPromote'
        },
        {
          name: 'Compare & Sync',
          icon: 'dashboard.svg',
          iconSelected: 'dashboard-light.svg',
          route: 'compare-object'
        },
        // {
        //   name: 'Compare Object',
        //   icon: 'dashboard.svg',
        //   iconSelected: 'dashboard-light.svg',
        //   route: 'compare-object'
        // }
      ]
    },
    {
      name: 'OneDesign',
      route: 'one-design',
      children: oneDesignChildren
    },
    {
      name: 'OneBusiness',
      route: 'one-business',
      children: [
        { name: 'User Provisioning', route: 'user-provisioning' },
        { name: 'Interaction Data & Recordings', route: 'interaction-data' },
      ]
    },
    {
      name: 'Reports',
      route: 'reports',
      children: reportChildren
    },
     {
      name: 'Backup',
      icon: 'backup.svg',            // optional icon file if you have one
      iconSelected: 'backup-light.svg', // optional selected icon
      route: 'backup'                // route for Backup component
    },
     {
      name: 'Help',
        icon: 'help.svg',
    },
  ];

  if (this.isPlatformAdmin) {
    this.navList.splice(5, 0, {
      name: 'Select Query',
      route: 'admin-pannel'
    },
    {
      name: 'User Management',
      route: 'admin-pannel/user-management'
    },
    {
      name: 'Clear Stuck Flow',
      route: 'admin-pannel/clear-stuck-flow'
    },
    {
      name: 'Read File',
      route: 'admin-pannel/read-file'
    });
  }
}

 
 
 
  activePage = 'dashboard';
  activeSection = 'dashboard'
 
  showUserMenu = false;
  onechange:boolean=false
  onechangePage:boolean=false
  onetrackAdvance:boolean=false
  dashboardPage:boolean=false
  flowPromote:boolean=false
  packagereport:boolean=false
  onetrack:boolean=false
  usermgmt:boolean=false
  gitdetails:boolean=false
  profilesection:boolean=false
  OneDesign:boolean=false
  copyEnv:boolean=false
 copyEnvReport:boolean=false
  usermanagement:boolean=false
  disasterRecovery:boolean=false
  reports:boolean=false
  memberShipPlan:string='';
  platformclient:any;
  oAuthApi:any=null;
  queryRes:any=[]
  oneDesignExpandedItem: string | null = null;
  showDrOrgSync: boolean = false;
    loadingFeatures: boolean = true;
    buildVersion:any
    buildVersionLabel:string=''
    buildVersionDateTime:string=''
  constructor(
    private routerQuery: RouterQuery,
    private userQuery: UserQuery,
     private ngZone: NgZone,
    private router: Router,
    private apiService: requestsService, private sanitizer: DomSanitizer,private cookie:CookieService,private config:Config,private toastr: ToastrService
    ,private geneSysService:GenesystokenService,) {

      this.apiService.getRoleListByUsername().subscribe(res=>{
        this.roleList=res
        this.userQuery.setRole(res);
         if(this.roleList?.role?.roleName=='Admin'){
           this.showManagement=true
         }
         else{
           this.showManagement=false
         }
       })
      if(this.geneSysService.tokenType=='aws'){
        this.userQuery.alreadyLogged().subscribe(user => {
          this.user = user;
        });
        this.apiService.getRoleListByUsername().subscribe(res=>{
         this.roleList=res
           this.userQuery.setRole(res); // store the response
          if(this.roleList?.role?.roleName=='Admin'){
            this.showManagement=true
          }
          else{
            this.showManagement=false
          }
          const email = ((res as any)?.emailAddress || (res as any)?.email || '').toLowerCase();
          if (email === 'hari.shankar@clarisys.com') {
            this.showDrOrgSync = true;
            this.buildNavList();
          }
        })
        Auth.currentUserInfo().then(res => {
          if (res && res.attributes) {
            this.userQuery.setUser(res.attributes);
            this.loadProfileImg();
          } else {
            // this.logout(); //commented on 14th july 2025
          }
        }, err => {
              this.logout();
        });
      }
      else{
        this.platformclient= (<any>window).platformClient;
        this.integrationsApi = new this.platformclient.IntegrationsApi();
        this.oAuthApi= new this.platformclient.OAuthApi();
        const usersApi = new this.platformclient.UsersApi();
        let opts = {'expand': ['authorization']};
        usersApi.getUsersMe(opts).then(res=>{
          this.user=res;
          this.geneSysService.setUser(res);
          this.loadProfileImg();
        }).catch((e) => {console.error(e);this.logout();});
   // return usersApi.getUsersMe(opts);
      }
      this.modules= [
        {roleModule:this.config.provisioningInfo.role,provisioningRoleInfoKey:'Role'},
        // {groupModule:this.config.provisioningInfo.group,provisioningGroupInfoKey:'Group'},
        {appInstanceModule:this.config.provisioningInfo.appinstance,provisioninagAppInstanceInfoKey:'app-instance'},
         {OAuthClientModule:this.config.provisioningInfo.oauthclient,provisioningOauthClientInfoKey:'oauth-client'},
        ];
   
  }
 
  ngOnInit(): void {
    this.MemberShipAPI()
    this.GetUserDetails()
    this.loadPlatformAdminAccess();
    this.loadingFeatures = true;
    this.routerQuery.select(routerData => routerData.state).subscribe(state => {
     
      if(state.url=='/home/one-change/package-groupe'||state.url=='/home/one-change/packagereport'||state.url=='/home/one-change/flowPromote'||state.url=='/home/one-change/compare-object'){
        this.visible=true
        this.OneDesignVisible=false
         this.reportvisible=false
      }
      if(state.url=='/home/one-design/copy-env'||state.url=='/home/one-design/disaster-recovery'||state.url=='/home/one-design/disaster-recovery/dr-org-sync'){
        this.visible=false
        this.OneDesignVisible=true
        this.reportvisible=false
        this.oneBusinessVisible=false
      }
      if(state.url.startsWith('/home/one-business/')){
        this.visible=false
        this.OneDesignVisible=false
        this.reportvisible=false
        this.oneBusinessVisible=true
      }
       if(state.url=='/home/reports/packagereport'||state.url=='/home/reports/copy-report'||state.url=='/home/reports/flowPromoteReport'||state.url=='/home/reports/provisioning-history'){
        this.visible=false
        this.OneDesignVisible=false
      this.reportvisible=true
      }
      this.queryRes=state
      window.scrollTo(0, 0);
      const path = state.url.split('/');
 
      if (path.length > 2) {
        this.activeSection = path[2];
        if (path.length > 3) {
          this.activePage = path[3].split('?')[0];
        } else {
          this.activePage = path.reverse()[0];
        }
      }
      if (state.url.includes('/home/one-design/copy-env/copy-report')) {
 this.activePage='copy-report'
this.OneDesignVisible=true
}
      if (state.url.includes('/home/one-design/disaster-recovery/dr-org-sync')) {
        this.activePage = 'dr-org-sync';
        this.oneDesignExpandedItem = 'disaster-recovery';
        this.OneDesignVisible = true;
      }
    });
    //  this.apiService.getOrgAuthenticatorAppMFA().subscribe(res=>{
    //     Auth.currentAuthenticatedUser().then(user => {console.log(user)
    //       if(res==true && user.preferredMFA=="NOMFA"){
    //         this.toastr.warning('Please enable authenticator App MFA to access the application');
    //        this.disableUser=true
    //       }
    //     })
    //   })
    if(this.geneSysService.tokenType=="aws"){
      // this.apiService.userPlanDetails().subscribe(res => {
      //   if (res) {
      //     this.memberShipPlan=res.membershipName
      //     this.userQuery.setCurrentPlan(res);
      //   }
 
      //   if (!res || res.id === 0 || res.id === '0') {
      //     this.router.navigateByUrl('/home/membership');
      //   }
      // });
 
      // active listner for plan changes. So we can update the feature availability
      this.userQuery.currentPlan().pipe(
        switchMap(res => {
          //this below return commented on 16/11/23
          return res
 
          //both line added on 16/11/23
          // console.log("beow return apiii")
          // return this.apiService.MembershipDetails();
        })
      ).subscribe((res: any) => {
       
        // this.availableFeatures.OneTrack = res.OneTrack;
        // this.availableFeatures.oneChange = res.oneChange;
        // this.availableFeatures.oneTrackAdvanced = res.oneTrackAdvanced;
      });
    }
   else{
    // this.apiService.userPlanDetails().subscribe(res => {
    //   if (res) {
    //     this.memberShipPlan=res.membershipName
    //     //this.userQuery.setCurrentPlan(res);
    //   }
 
    //   if (!res || res.id === 0 || res.id === '0') {
    //     this.router.navigateByUrl('/home/membership');
    //   }
    // });
 
    // this.apiService.getTestTypeForUser().subscribe((res: any) => {
    //   this.availableFeatures.AutomaticTesting = res.AutomaticTesting;
    //   this.availableFeatures.LoadTesting = res.LoadTesting;
    //   this.availableFeatures.ScheduledTesting = res.ScheduledTesting;
    // });
   }
 
    // this.myBrowser();
  }
  private loadPlatformAdminAccess(): void {
    if (this.geneSysService.tokenType !== 'aws') {
      this.isPlatformAdmin = false;
      return;
    }
    this.apiService.isPlatFormAdmin().subscribe((res: any) => {
      this.isPlatformAdmin = this.isPlatformAdminResponse(res);
      if (this.isPlatformAdmin) {
        this.apiService.oneCgBuildVersion().subscribe(res => {
          this.buildVersion=res
          this.setBuildVersionDisplay(res);
          localStorage.setItem('qtBuildVersion', JSON.stringify(res));
        });
      }
      this.buildNavList();
    }, () => {
      this.isPlatformAdmin = false;
      this.buildNavList();
    });
  }

  private isPlatformAdminResponse(res: any): boolean {
    if (typeof res === 'boolean') {
      return res;
    }
    if (res && typeof res === 'object') {
      return !!(res.isPlatFormAdmin || res.isPlatformAdmin || res.data);
    }
    return false;
  }

  private setBuildVersionDisplay(buildRes: any): void {
    const normalized = this.normalizeBuildVersionResponse(buildRes);
    this.buildVersionLabel = normalized.version;
    this.buildVersionDateTime = normalized.dateTime;
  }

  private normalizeBuildVersionResponse(buildRes: any): { version: string; dateTime: string } {
    if (typeof buildRes === 'string') {
      const [rawVersion, rawDateTime] = buildRes.split('|');
      return {
        version: (rawVersion || '').trim(),
        dateTime: this.formatBuildDateTime(rawDateTime)
      };
    }

    if (buildRes && typeof buildRes === 'object') {
      if (typeof buildRes.data === 'string') {
        const [rawVersion, rawDateTime] = buildRes.data.split('|');
        return {
          version: (rawVersion || '').trim(),
          dateTime: this.formatBuildDateTime(rawDateTime)
        };
      }
      const versionRaw = buildRes.buildVersion || buildRes.version || buildRes.oneCGBuildVersion || '';
      const dateTimeRaw = buildRes.buildDateTime || buildRes.dateTime || buildRes.updatedAt || buildRes.createdAt || buildRes.timestamp || '';
      return {
        version: String(versionRaw || '').trim(),
        dateTime: this.formatBuildDateTime(dateTimeRaw)
      };
    }

    return { version: '', dateTime: '' };
  }

  private formatBuildDateTime(dateTimeValue: any): string {
    if (!dateTimeValue) {
      return '';
    }

    const dateObj = new Date(dateTimeValue);
    if (Number.isNaN(dateObj.getTime())) {
      return String(dateTimeValue);
    }

    return dateObj.toLocaleString();
  }
MemberShipAPI(){
  this.apiService.AWSMembershipDetails().subscribe(res=>{
    this.Membershipres=res
    this.userQuery.setMemmbershipAPIRes(this.Membershipres)
this.availableFeatures.OneTrack = this.Membershipres.oneTrackLite;
  this.availableFeatures.oneChange = this.Membershipres.onechange;
  this.availableFeatures.oneTrackAdvanced = this.Membershipres.oneTrackAdvanced;
  this.availableFeatures.oneDesignOneClone=this.Membershipres.oneDesignOneClone;
  this.availableFeatures.oneDesignOneSync=this.Membershipres.oneDesignOneSync;
    // Build navList after setting flags
    this.buildNavList();
    setTimeout(()=>{
      if (this.Membershipres.oneTrackLite===true && (this.Membershipres.oneDesignOneClone===false||this.Membershipres.oneTrackAdvanced===false
||this.Membershipres.oneDesignOneSync===false||this.Membershipres.onechange===false)) {
      this.ngZone.run(() => {
        this.router.navigateByUrl('/home/OneTrack-Lite');
      });
    }
 
    // ✅ Done loading — now allow view to render
    this.loadingFeatures = false;
    },400)
    
  }, () => {
    // On API error, still build nav with defaults and release loading state
    this.loadingFeatures = false;
    this.buildNavList();
  })
}
GetUserDetails(){
  this.apiService.AWSUserDetails().subscribe(s=>{})
}
  loadProfileImg() {
    // this.apiService.getProfileImg().subscribe(res => {
    //   console.log(res)
    //   if (res) {
    //     if(res.size==0){
    //       this.thumbnail ="../../assets/dummy-profile-pic.jpg"
    //       this.userQuery.setUserImg(this.thumbnail);
    //     }
    //     else{
    //       var unsafeImageUrl = URL.createObjectURL(res);
    //       this.thumbnail = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
    //       // var unsafeImageUrl = URL.createObjectURL(res.blob());
    //       // this.thumbnail = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
    //       if(this.geneSysService.tokenType=='genesys'){
    //         this.geneSysService.setUserImg(res);
    //       }
    //       else{
    //         this.userQuery.setUserImg(res);
    //       }
           
    //     }
       
    //   }
    //   console.log('000')
    // }, err => {
    //   this.thumbnail ="../../assets/dummy-profile-pic.jpg"
    //   if(this.geneSysService.tokenType=='genesys'){
    //     this.geneSysService.setUserImg(this.thumbnail);
    //   }
    //   else{
    //     this.userQuery.setUserImg(this.thumbnail);
    //   }
    //   console.log(err)
    //   console.log('---')
    // });
  }
 
  toggleSidePanel() {
    let value;
   value= this.viewDOM.nativeElement.classList.toggle('wide');
    if(value==true){
      this.visible=false
        this.OneDesignVisible=false
         this.reportvisible=false
         this.oneBusinessVisible=false
    }
     
  }
    //onclick toggling both
    onclick()
    {
      this.visible = !this.visible
      this.OneDesignVisible=false
      this.reportvisible=false
      this.oneBusinessVisible=false
    }
    oneDesignlick(){
      this.OneDesignVisible= !this.OneDesignVisible
      this.visible = false
      this.reportvisible=false
      this.oneBusinessVisible=false
    }
   
    onclick1()
    {
      this.visible = false
      this.OneDesignVisible=false
      this.reportvisible=false
      this.oneBusinessVisible=false
    }
    Reportlick(){
      this.reportvisible=!this.reportvisible
       this.OneDesignVisible=false
      this.visible = false
      this.oneBusinessVisible=false
    }
    oneBusinesslick(){
      this.oneBusinessVisible= !this.oneBusinessVisible
      this.visible=false
      this.OneDesignVisible=false
      this.reportvisible=false
    }
    selectMenu3(route){
      window.open('#/home/one-business/'+route)
      localStorage.setItem('tabBrowserService','/home/one-business/'+route)
    }
//   uninstall() {
//     let promiseArr = [];
 
//     this.modules.forEach((module) => {
//       console.log(module)
//         promiseArr.push(
//             module.delete()
//         );
//     });
//     window.location.href = `${this.config.wizardUriBase}?${this.config.genesysCloudEnvironmentQueryParam}=${this.config.defaultPcEnvironment}&${this.config.languageQueryParam}="${this.config.defaultLanguage}"`;
 
//     return Promise.all(promiseArr);
// }
selectMenu(route){
  // '/home/'+route;
    window.open('#/home/'+route)
    localStorage.setItem("tabBrowserService",'/home/'+route)
}
selectMenu1(route){
  // '/home/'+route;
    window.open('#/home/one-change/'+route)
    localStorage.setItem("tabBrowserService",'/home/one-change/'+route)
}
selectMenu2(route){
  // '/home/'+route;
    window.open('#/home/one-design/'+route)
    localStorage.setItem("tabBrowserService",'/home/one-design/'+route)
}
  userMenuToggler() {
    this.showUserMenu = !this.showUserMenu;
  }
  OnechangeItem(){
this.onechangeSubitem=true
 
  }
  navTo(url) {
    this.userMenuToggler();
    this.router.navigateByUrl(url);
  }
  closeDropdown() {
    if (this.showUserMenu == true) {
      this.showUserMenu = false;
    }else{
      return;
    }
  }
 // Hari Sir told me to remove this uninstall on 15/02/24
//   uninstall(){
//     let del_app = [];
//     console.log(this.geneSysService,this.config.provisioningInfo)
//     if(this.geneSysService.genesysUserexists.length>0){
//       const IdOfApp = this.geneSysService.genesysUserexists.filter((item: any) => item.name ==this.config.provisioningInfo.appinstance[0].name)[0].id;
//         console.log(IdOfApp)
//         del_app.push(this.integrationsApi.deleteIntegration(IdOfApp).then(res=>{
//           if(res){
//             window.location.reload();
//              this.router.navigateByUrl("/");
//           }
//         }));
//         console.log(del_app)
//       //  })
//     }
//     if(this.geneSysService.ClientGensysUser.entities.length>0){
//         const IdOfClient = this.geneSysService.ClientGensysUser.entities.filter((item: any) => item.name == this.config.provisioningInfo.appinstance[0].name)[0].id;
//         console.log(IdOfClient)
//         if(IdOfClient){
//         del_app.push(this.oAuthApi.deleteOauthClient(IdOfClient).then(res=>{
//           if(res){
//           this.router.navigateByUrl("/");
//           }
//         }));
//         }
//     }
//     console.log(this.geneSysService)
//     console.log(del_app)
//     return Promise.all(del_app);
//     // console.log(this.msgToSibling)
//     let promiseArr = [];
//     // this.modules.remove()
//     // this.modules.forEach((module) => {
//     //     // promiseArr.push(
//     //       this.modules.splice()
//     //     // );
//     //     console.log(this.modules);
//     //   // promiseArr.forEach((item)=>{
//     //   //   console.log(item)
//     //   // })
//     //   console.log(promiseArr)
//     // });
//     // this.modules.splice(0,this.modules.length)
//     // console.log(this.modules)
//     // return Promise.all(this.modules);
// }
//newUI this is also correct
// logout() {
//   console.log("newLogoutFunction at 5pm")
//   const isSaml=this.userQuery.getSamlUser()
//   localStorage.removeItem("UserCred");
//   this.cookie.remove("startDate");
//   this.cookie.remove("endDate");
//   this.cookie.remove("SamlUser");
//   this.cookie.remove("token");
//   this.cookie.remove("SamlUser")               
//   this.userQuery.logout();

//   // ---- redirect based on login type ----
//   if (isSaml) {
//     window.location.href =
//       "https://onecgcloud-lab.auth.eu-west-2.amazoncognito.com/logout?client_id=5sur3nfo0tfvlao1t8m2d7mfpt&logout_uri=https%3A%2F%2Fonecg-preprod-samlintegration.d3bijszcmlj4kq.amplifyapp.com%2F";
//   } else {
//     this.router.navigateByUrl('/');
//   }
// }

async logout() {
  const isSaml = this.userQuery.getSamlUser();
  let refreshToken: string | null = null;
  try {
    const session = await Auth.currentSession();
    refreshToken = session.getRefreshToken().getToken();
  } catch (e) {}
  const parms = {
    refreshToken: refreshToken,
    clientId: '5sur3nfo0tfvlao1t8m2d7mfpt'
  };
  this.apiService.logout(parms).subscribe(res => {
  });
  // Clear only local app storage (this part is fine)
  localStorage.removeItem("UserCred");
  this.cookie.remove("startDate");
  this.cookie.remove("endDate");
  this.cookie.remove("SamlUser");
  this.cookie.remove("token");

  // Reset app state

  // Akita user logout
  this.apiService.clearEnvListCache();
  this.geneSysService.reset();
  this.clearAppStorageAndCookies();
  this.userQuery.logout();
}

  showHidePanelFn() {
    this.contractSidebar = !this.contractSidebar;
  }
  closeNav(){
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("menuHeaderpanel").style.width = "100%";
    //document.getElementById("allMainPage").style.width = "100%";
    //this.settingWidth="routerletwidth"
    this.settingWidth=false
  }
  openNav(){
    document.getElementById("mySidenav").style.width = "300px";
    this.settingWidth=true
    document.getElementById("menuHeaderpanel").style.width = "80%";
    //this.settingWidth="opennavigationrouterwidth"
  }
  toggleOneDesignSub(route: string) {
    this.oneDesignExpandedItem = this.oneDesignExpandedItem === route ? null : route;
  }
  UserGuide() {
    window.open('assets/icons/userguide.html', '_blank');
  }
    private clearAppStorageAndCookies() {
    localStorage.clear();
    sessionStorage.clear();
    this.cookie.removeAll();
    this.clearBrowserCookies();
  }
    private clearBrowserCookies() {
    const cookies = document.cookie ? document.cookie.split(';') : [];
    const hostParts = window.location.hostname.split('.');
    const domains: string[] = [];
    for (let i = 0; i < hostParts.length; i++) {
      domains.push(hostParts.slice(i).join('.'));
    }
    cookies.forEach((cookieItem) => {
      const eqPos = cookieItem.indexOf('=');
      const name = (eqPos > -1 ? cookieItem.slice(0, eqPos) : cookieItem).trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      domains.forEach((domain) => {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${domain}`;
      });
    });
  }
}
